module.exports = __webpack_public_path__ + "img/print_handprint.4faeab3.jpg";